<template>
  <div>
    <!-- Tela Normal (printMode = false) -->
    <div v-if="!printMode">
      <h6>Despesas a Pagar</h6><p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <button @click="abrirPrint" class="btn btn-primary">Executar</button>
        </div>
      </div>
    </div>

    <!-- Modo Impressão (printMode = true) -->
    <div v-else>
      <!-- <h4>{{ printTitle }}</h4> -->
      <div v-if="loading">Carregando…</div>
      <div v-else-if="resultados.length">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>REFIL</th>
              <th>DESCRIÇÃO</th>
              <th class="valor-cell">VALOR</th>
              <th class="text-center">FORMA DE PAGAMENTO</th>
              <th class="text-center">DATA VENCIMENTO</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in resultados" :key="idx">
              <td>{{ item.refil }}</td>
              <td>{{ item.descricao }}</td>
              <td class="valor-cell">{{ formatarMoeda(item.valor) }}</td>
              <td class="text-center">{{ item.forma_pagamento }}</td>
              <td class="text-center">{{ formatarData(item.data_vencimento) }}</td>
            </tr>
          </tbody>

          <!-- Rodapé com o total (aparece somente se resultados.length > 0) -->
          <tfoot v-if="resultados.length">
            <tr>
              <!-- "Total" ocupa as duas primeiras colunas -->
              <td colspan="2"><strong>Total</strong></td>
              <!-- Exibe o total na coluna "VALOR" -->
              <td class="valor-cell"><strong>{{ formatarMoeda(totalDespesas) }}</strong></td>
              <!-- As duas colunas seguintes ficam vazias -->
              <td colspan="2"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <p>Nenhuma despesa a pagar no momento.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'

const props = defineProps({
  printMode:  { type: Boolean, default: false },
  printTitle: String
})

const router = useRouter()
const loading        = ref(false)
const resultados     = ref([])
const totalDespesas  = ref(0)

/**
 * Quando em modo “print”, busca os dados e o total
 */
onMounted(async () => {
  if (!props.printMode) return

  loading.value = true
  try {
    const res = await axios.get('/gestao/relatorios/despesas/despesas-a-pagar')
    // Como o endpoint agora retorna { items: [...], total: 1234.56 }
    resultados.value = Array.isArray(res.data.items) ? res.data.items : []
    // Garantir que total seja número (pode vir como string)
    totalDespesas.value = parseFloat(res.data.total) || 0
  } catch (e) {
    console.error('Erro em APagar (print):', e)
    resultados.value = []
    totalDespesas.value = 0
  } finally {
    loading.value = false
  }
})

/**
 * Função disparada ao clicar em "Executar" no modo tela
 * Redireciona para rota de print, que usa ReportPrintWrapper.vue
 */
function abrirPrint() {
  router.push({
    path: `/gestao/relatorios/print/despesas-a-pagar`,
    query: { title: 'Despesas a Pagar' }
  })
}

/**
 * Formata string de data (YYYY-MM-DD ou ISO) para "dd/MM/yyyy"
 */
function formatarData(dateStr) {
  if (!dateStr) return ''
  const d   = new Date(dateStr)
  const dia = String(d.getDate()).padStart(2, '0')
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const ano = d.getFullYear()
  return `${dia}/${mes}/${ano}`
}

/**
 * Formata número para moeda brasileira "R$ X.xxx,xx"
 */
function formatarMoeda(num) {
  if (num == null) return ''
  return Number(num).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.valor-cell {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
</style>
